import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { TopLogoBar } from "@/components/AppShell";
import { PasswordInput } from "@/components/PasswordInput";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const inputCls = "mt-1 w-full rounded-2xl border border-[#27272A] bg-[#121215] px-4 py-3.5 text-[#F4F4F5] outline-none placeholder:text-[#8A8E96] focus:border-[#D4AF37]/50";

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Le due password non coincidono");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password aggiornata");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen px-5 pb-10 pt-6" data-testid="reset-password-page">
      <TopLogoBar onBack={() => navigate("/accedi")} testid="reset-back-button" />

      {!token ? (
        <div className="mt-16 text-center">
          <p className="text-base text-[#B4B4BC]">Link di reset non valido o incompleto.</p>
          <Link to="/accedi" className="mt-4 inline-block font-semibold text-[#D4AF37]">Torna all'accesso</Link>
        </div>
      ) : done ? (
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="mt-16 text-center" data-testid="reset-success">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#D4AF37]/12 text-[#D4AF37]">
            <ShieldCheck size={26} />
          </div>
          <h1 className="font-serif-el mt-4 text-2xl font-semibold text-[#FAF9F6]">Password aggiornata</h1>
          <p className="mt-2 text-base text-[#B4B4BC]">Ora puoi accedere con la tua nuova password.</p>
          <button onClick={() => navigate("/accedi")} data-testid="reset-goto-login" className="btn-gold mt-6 w-full rounded-full px-6 py-4 text-base uppercase tracking-wide">
            Accedi
          </button>
        </motion.div>
      ) : (
        <>
          <div className="mt-10">
            <p className="eyebrow">Recupero accesso</p>
            <h1 className="font-serif-el mt-2 text-3xl font-semibold text-[#FAF9F6]">Scegli una nuova password</h1>
            <p className="mt-2 text-base text-[#B4B4BC]">Inseriscila due volte per confermarla.</p>
          </div>
          <motion.form onSubmit={submit} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="mt-8 space-y-3.5">
            <div>
              <label className="text-sm font-semibold text-[#B4B4BC]">Nuova password</label>
              <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} testId="reset-password-input" autoComplete="new-password" className={inputCls} />
            </div>
            <div>
              <label className="text-sm font-semibold text-[#B4B4BC]">Conferma password</label>
              <PasswordInput value={confirm} onChange={(e) => setConfirm(e.target.value)} testId="reset-confirm-input" placeholder="Ripeti la password" autoComplete="new-password" className={inputCls} />
            </div>
            <button type="submit" disabled={loading} data-testid="reset-submit-button" className="btn-gold w-full rounded-full px-6 py-4 text-base uppercase tracking-wide">
              {loading ? "Un momento…" : "Aggiorna password"}
            </button>
          </motion.form>
        </>
      )}
    </div>
  );
}
